<template>
  <div class="dp_flex">
    <sui-custom-select
      :selected="currentSelectedNation"
      :option-list="nationOptionList"
      :disabled="nationDisabled || disabled"
      :style="customStyle"
      @list-clicked="onChangeNationSelect"
      @selection-changed="onNationSelectionChanged"
    />
    <div class="comp_spacing" />
    <sui-custom-select
      :selected="currentSelectedSite"
      :option-list="siteOptionList"
      :disabled="siteDisabled || disabled"
      :style="customStyle"
      @list-clicked="onChangeSiteSelect"
      @selection-changed="onSiteSelectionChanged"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import selectUtil from '~common/js//select-util.js';

export default {
  name: 'CmpNationSiteSelect',
  props: {
    // 이 컴포넌트를 사용하는 페이지ID
    pageId: {
      type: String,
      required: true,
    },
    selectedNation: {
      type: Object,
      required: true,
      default() {
        return {
          key: '',
          label: '',
        };
      },
    },
    selectedSite: {
      type: Object,
      required: true,
      default() {
        return {
          key: '',
          label: '',
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    nationDisabled: {
      type: Boolean,
      default: false,
    },
    siteDisabled: {
      type: Boolean,
      default: false,
    },
    applyAuthorityYn: {
      type: String,
      default: 'Y',
    },
    initialSelectedNationCd: {
      type: String,
      default: '',
    },
    initialSelectedSiteId: {
      type: String,
      default: '',
    },
    initialSelectedNationIndex: {
      type: Number,
      default: -1,
    },
    initialSelectedSiteIndex: {
      type: Number,
      default: -1,
    },
    defaultNationOption: {
      type: String,
      default: 'all',
    },
    defaultSiteOption: {
      type: String,
      default: 'all',
    },
    customStyle: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      nationSiteList: [],
      nationOptionList: [],
      siteOptionList: [],
      currentSelectedNation: {
        label: '',
        key: null,
      },
      currentSelectedSite: {
        label: '',
        key: null,
      },
      nationSiteLoaded: false,
    };
  },
  computed: {
    /*
    isDisabled() {
      if (this.disabled || !this.nationSiteLoaded) {
        return true;
      }
      return false;
    },
    */
  },
  watch: {
    selectedNation: {
      deep: true,
      handler(n, o) {
        if (n !== o) {
          if (this.selectedNation) {
            if (this.selectedNation.key !== '') {
              this.selectNationByKey(this.selectedNation.key);
            } else {
              this.resetNation();
            }
            this._syncProp();
            this.emitEvent();
          }
        }
      },
    },
    selectedSite: {
      deep: true,
      handler(n, o) {
        if (n !== o) {
          if (this.selectedSite) {
            if (this.selectedSite.key !== '') {
              this.selectNationBySiteId(this.selectedSite.key);
            } else {
              this.selectSiteByKey('');
            }
            this._syncProp();
            this.emitEvent();
          }
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this._load();
    });
  },
  methods: {
    reset() {
      this.currentSelectedNation = {
        label: '',
        key: null,
      };
      this.currentSelectedSite = {
        label: '',
        key: '',
      };
      this.selectedSite.key = this.$store.getters.userInfo.siteId;
      this._load();
    },
    _load() {
      let that = this;
      // api 호출
      that.getNationSiteList().then(tempNationOptionList => {
        // 국가 select 목록 데이터 구성
        that.nationOptionList = selectUtil.mergeDefaultOption(tempNationOptionList, that.defaultNationOption);

        if (that.selectedSite.key) {
          that.selectNationBySiteId(that.selectedSite.key);
        } else if (that.initialSelectedSiteId !== '') {
          that.selectNationBySiteId(that.initialSelectedSiteId);
        } else if (that.initialSelectedSiteIndex >= 0 && that.siteOptionList.length > that.initialSelectedSiteIndex) {
          that.selectNationBySiteId(that.siteOptionList[that.initialSelectedSiteIndex].key);
        } else if (that.selectedNation.key) {
          that.selectNationByKey(that.selectedNation.key);
        } else if (that.initialSelectedNationCd !== '') {
          that.selectNationByKey(that.initialSelectedNationCd);
        } else if (that.initialSelectedNationIndex >= 0
          && that.nationOptionList.length > that.initialSelectedNationIndex) {
          that.selectNationByKey(that.nationOptionList[that.initialSelectedNationIndex].key);
        } else {
          that.selectNationBySiteId(that.$store.getters.userInfo.siteId);
        }
        that.nationSiteLoaded = true;
        // that.$emit('loaded', that.nationOptionList);
        this._syncProp();
        this.emitEvent();
      }).catch(err => {
        console.log(err);
      });
    },
    /**
     * 국가 사이트 목록 조회결과를 반환한다.
     * @function getNationSiteList
     * @returns {Promise}
     */
    getNationSiteList() {
      const that = this;
      return new Promise((resolve, reject) => {
        http.request(that.pageId, 'DTS_CMZ_00147', {
          query: {
            applyAuthorityYn: that.applyAuthorityYn,
          },
        }).then(res => {
          // 조회결과 데이터 저장
          that.nationSiteList = res.data;
          
          // 국가코드 기준으로 중복제거 하고 국가명으로 정렬
          const tempNationList = _.sortBy(_.uniqBy(res.data, itm => itm.nationCode), itm2 => itm2.nationName);
          // 국가코드, 국가명 property 만 가진 object array에 담아서 넘김
          const tempNationOptionList = [];
          utils.forEach(tempNationList, option => {
            tempNationOptionList.push({
              label: option.nationName,
              key: option.nationCode,
            });
          });
          resolve(tempNationOptionList);
        }).catch(err => {
          reject(err);
        });
      });
    },
    /**
     * 국가 select 를 다시 set
     */
    resetNation() {
      // return this.reset();
      this.selectNationByKey(this.nationOptionList[0].key);

    },
    /**
     * 특정 국가코드로 국가 select
     */
    selectNationByKey(nationCode) {
      this.selectNation({
        key: nationCode,
      });
    },
    selectNationBySiteId(siteId) {
      const nationSiteOption = utils.find(this.nationSiteList, { siteId });
      const nationCode = utils.isEmpty(nationSiteOption) ? '' : nationSiteOption.nationCode;
      this.selectNationByKey(nationCode);
      this.selectSiteByKey(siteId);
    },
    /**
     * 특정 국가코드로 국가 select
     */
    selectNation(selectedNation) {
      this.currentSelectedNation = selectedNation;
      this.resetSiteByNation(selectedNation);
    },
    /**
     * 특정 국가코드 기준으로 사업장 select 를 다시 설정
     */
    resetSiteByNationKey(nationCode) {
      this.resetSiteByNation({
        key: nationCode,
      });
    },
    /**
     * 특정 국가코드 기준으로 사업장 select 를 다시 설정
     */
    resetSiteByNation(selectedNation) {
      let tempSiteOptionList = [];
      if (utils.isEmpty(selectedNation)) {
        tempSiteOptionList = [];
      } else if (selectedNation.key === 'ALL') {
        // 국가코드가 ALL이기 때문에 모든 사업장을 정렬만 해서 표현
        tempSiteOptionList = _.sortBy(this.nationSiteList, itm => itm.siteAbbreviationName);
      } else if (selectedNation.key === ' ') {
        // 국가코드가 '선택'이기 때문에 사업장을 표시할 수 없음
        tempSiteOptionList = [];
      } else {
        // 국가 사업장 목록에서 특정국가코드로 필터링하고 사업장명으로 정렬
        tempSiteOptionList = _.sortBy(
          _.filter(this.nationSiteList, itm => itm.nationCode === selectedNation.key), itm2 => itm2.siteAbbreviationName);
      }
      // 새로운 사업장 select 목록을 만듬
      this.siteOptionList = [];
      utils.forEach(tempSiteOptionList, option => {
        this.siteOptionList.push({
          label: option.siteAbbreviationName,
          key: option.siteId,
        });
      });
      this.siteOptionList = selectUtil.mergeDefaultOption(this.siteOptionList, this.defaultSiteOption);
      this.selectSiteByKey(this.siteOptionList[0].key);
      // this.$emit('loaded', this.siteOptionList);
    },
    /**
     * 특정 사업장ID 로 사업장 select
     */
    selectSiteByKey(siteId) {
      if (utils.isEmpty(siteId)) {
        this.selectSite({
          key: this.siteOptionList[0].key,
        });
      } else {
        this.selectSite({
          key: siteId,
        });
      }
    },
    /**
     * 특정 사업장ID 로 사업장 select
     */
    selectSite(selectedSite) {
      this.currentSelectedSite = selectedSite;
      // this.emitEvent(); -> 여기에 두면 상위로 이벤트를 두번씩 날리는 경우가 있어 일단 여기서는 제거
    },
    /**
     * 사용자가 국가 select 를 변경했을 때 event handler
     */
    onChangeNationSelect() {
      this.resetSiteByNation(this.currentSelectedNation);
      this._syncProp();
      this.emitEvent();
    },
    /**
     * 사용자가 사업장 select 를 변경했을 때 event handler
     */
    onChangeSiteSelect() {
      this._syncProp();
      this.emitEvent();
    },
    /**
     * 국가 select option list 변경 이벤트 핸들러
     * @function onNationSelectionChanged
     */
    onNationSelectionChanged() {
      // 당장 이놈에게 시킬 일이 없음
    },
    /**
     * 사엽장 select option list 변경 이벤트 핸들러
     * @function onSiteSelectionChanged
     */
    onSiteSelectionChanged() {
      // 당장 이놈에게 시킬 일이 없음
    },
    /**
     * select-changed 이벤트를 emit하고 국가 select 와 사업장 select의 현재 선택된 값을 배열에 담아서 넘긴다.
     * @function emitEvent
     * @returns {Array}
     */
    emitEvent() {
      const _arr = [];
      _arr.push(this.currentSelectedNation);
      _arr.push(this.currentSelectedSite);
      this.$emit('select-changed', _arr);
    },
    /**
     * 컴포넌트 prop 에 현재 값을 덮어씌우기
     */
    _syncProp() {
      if (this.currentSelectedNation.key !== this.selectedNation.key) {
        this.selectedNation.label = this.currentSelectedNation.label;
        this.selectedNation.key = this.currentSelectedNation.key;
      }
      if (this.currentSelectedSite.key !== this.selectedSite.key) {
        this.selectedSite.label = this.currentSelectedSite.label;
        this.selectedSite.key = this.currentSelectedSite.key;
      }
    },
  },
};
</script>

<style lang="css" scoped>
</style>
